"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));
var _colors = _interopRequireDefault(require("@argo/principles/colors"));
var _core = require("@emotion/core");
var _react = _interopRequireDefault(require("react"));
var circleStyles = function circleStyles(_ref) {
  var circleColor = _ref.circleColor,
    circlePadding = _ref.circlePadding,
    circleBorderRadius = _ref.circleBorderRadius;
  return circleColor && (0, _core.css)("padding:", circlePadding, ";background-color:", circleColor, ";border-radius:", circleBorderRadius, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pY29ucy9JY29uQmFzZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPSyIsImZpbGUiOiIuLi8uLi9zcmMvaWNvbnMvSWNvbkJhc2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgY29sb3JzIGZyb20gJ0BhcmdvL3ByaW5jaXBsZXMvY29sb3JzJztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuY29uc3QgY2lyY2xlU3R5bGVzID0gKHsgY2lyY2xlQ29sb3IsIGNpcmNsZVBhZGRpbmcsIGNpcmNsZUJvcmRlclJhZGl1cyB9KSA9PlxuICBjaXJjbGVDb2xvciAmJlxuICBjc3NgXG4gICAgcGFkZGluZzogJHtjaXJjbGVQYWRkaW5nfTtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NpcmNsZUNvbG9yfTtcbiAgICBib3JkZXItcmFkaXVzOiAke2NpcmNsZUJvcmRlclJhZGl1c307XG4gIGA7XG5cbmNvbnN0IFN0eWxlZEljb24gPSBzdHlsZWQoJ3N2ZycpYFxuICAke2NpcmNsZVN0eWxlc31cbiAgaGVpZ2h0OiAkeyh7IHNpemUgfSkgPT4gc2l6ZX1weDtcbiAgd2lkdGg6ICR7KHsgc2l6ZSB9KSA9PiBzaXplfXB4O1xuICBmaWxsOiAkeyh7IGNvbG9yIH0pID0+XG4gICAgY29sb3JzLnByaW1hcnlbY29sb3JdIHx8XG4gICAgY29sb3JzLm5ldXRyYWxbY29sb3JdIHx8XG4gICAgY29sb3JzLmFjdGlvbltjb2xvcl0gfHxcbiAgICBjb2xvcn07XG4gIHN0cm9rZTogJHsoeyBjb2xvciB9KSA9PlxuICAgIGNvbG9ycy5wcmltYXJ5W2NvbG9yXSB8fFxuICAgIGNvbG9ycy5uZXV0cmFsW2NvbG9yXSB8fFxuICAgIGNvbG9ycy5hY3Rpb25bY29sb3JdIHx8XG4gICAgY29sb3J9O1xuICAkeyh7IGFjdGlvbkljb24gfSkgPT4gKGFjdGlvbkljb24gPyAnY3Vyc29yOiBwb2ludGVyOycgOiAnJyl9XG5gO1xuXG5jb25zdCBJY29uQmFzZSA9IHByb3BzID0+IChcbiAgPFN0eWxlZEljb25cbiAgICB7Li4ucHJvcHN9XG4gICAgeD1cIjBweFwiXG4gICAgeT1cIjBweFwiXG4gICAgdmlld0JveD17cHJvcHMudmlld0JveCA/IHByb3BzLnZpZXdCb3ggOiAnMCAwIDY0IDY0J30+XG4gICAge3Byb3BzLnRpdGxlICYmIDx0aXRsZT57cHJvcHMudGl0bGV9PC90aXRsZT59XG4gICAge3Byb3BzLmNoaWxkcmVufVxuICA8L1N0eWxlZEljb24+XG4pO1xuXG5JY29uQmFzZS5kaXNwbGF5TmFtZSA9ICdJY29uQmFzZSc7XG5cbkljb25CYXNlLmRlZmF1bHRQcm9wcyA9IHtcbiAgc2l6ZTogMjQsXG4gIGNvbG9yOiAnZGFya0JyaWdodEJsdWUnLFxuICBjaXJjbGVDb2xvcjogbnVsbCxcbiAgY2lyY2xlUGFkZGluZzogJzNweCcsXG4gIGNpcmNsZUJvcmRlclJhZGl1czogJzUwJScsXG4gIGFjdGlvbkljb246IGZhbHNlLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgSWNvbkJhc2U7XG4iXX0= */"));
};
var StyledIcon = (0, _styledBase["default"])('svg', {
  target: "e1vcxgeb0",
  label: "StyledIcon"
})(circleStyles, " height:", function (_ref2) {
  var size = _ref2.size;
  return size;
}, "px;width:", function (_ref3) {
  var size = _ref3.size;
  return size;
}, "px;fill:", function (_ref4) {
  var color = _ref4.color;
  return _colors["default"].primary[color] || _colors["default"].neutral[color] || _colors["default"].action[color] || color;
}, ";stroke:", function (_ref5) {
  var color = _ref5.color;
  return _colors["default"].primary[color] || _colors["default"].neutral[color] || _colors["default"].action[color] || color;
}, ";", function (_ref6) {
  var actionIcon = _ref6.actionIcon;
  return actionIcon ? 'cursor: pointer;' : '';
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pY29ucy9JY29uQmFzZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFhZ0MiLCJmaWxlIjoiLi4vLi4vc3JjL2ljb25zL0ljb25CYXNlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IGNvbG9ycyBmcm9tICdAYXJnby9wcmluY2lwbGVzL2NvbG9ycyc7XG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IGNpcmNsZVN0eWxlcyA9ICh7IGNpcmNsZUNvbG9yLCBjaXJjbGVQYWRkaW5nLCBjaXJjbGVCb3JkZXJSYWRpdXMgfSkgPT5cbiAgY2lyY2xlQ29sb3IgJiZcbiAgY3NzYFxuICAgIHBhZGRpbmc6ICR7Y2lyY2xlUGFkZGluZ307XG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHtjaXJjbGVDb2xvcn07XG4gICAgYm9yZGVyLXJhZGl1czogJHtjaXJjbGVCb3JkZXJSYWRpdXN9O1xuICBgO1xuXG5jb25zdCBTdHlsZWRJY29uID0gc3R5bGVkKCdzdmcnKWBcbiAgJHtjaXJjbGVTdHlsZXN9XG4gIGhlaWdodDogJHsoeyBzaXplIH0pID0+IHNpemV9cHg7XG4gIHdpZHRoOiAkeyh7IHNpemUgfSkgPT4gc2l6ZX1weDtcbiAgZmlsbDogJHsoeyBjb2xvciB9KSA9PlxuICAgIGNvbG9ycy5wcmltYXJ5W2NvbG9yXSB8fFxuICAgIGNvbG9ycy5uZXV0cmFsW2NvbG9yXSB8fFxuICAgIGNvbG9ycy5hY3Rpb25bY29sb3JdIHx8XG4gICAgY29sb3J9O1xuICBzdHJva2U6ICR7KHsgY29sb3IgfSkgPT5cbiAgICBjb2xvcnMucHJpbWFyeVtjb2xvcl0gfHxcbiAgICBjb2xvcnMubmV1dHJhbFtjb2xvcl0gfHxcbiAgICBjb2xvcnMuYWN0aW9uW2NvbG9yXSB8fFxuICAgIGNvbG9yfTtcbiAgJHsoeyBhY3Rpb25JY29uIH0pID0+IChhY3Rpb25JY29uID8gJ2N1cnNvcjogcG9pbnRlcjsnIDogJycpfVxuYDtcblxuY29uc3QgSWNvbkJhc2UgPSBwcm9wcyA9PiAoXG4gIDxTdHlsZWRJY29uXG4gICAgey4uLnByb3BzfVxuICAgIHg9XCIwcHhcIlxuICAgIHk9XCIwcHhcIlxuICAgIHZpZXdCb3g9e3Byb3BzLnZpZXdCb3ggPyBwcm9wcy52aWV3Qm94IDogJzAgMCA2NCA2NCd9PlxuICAgIHtwcm9wcy50aXRsZSAmJiA8dGl0bGU+e3Byb3BzLnRpdGxlfTwvdGl0bGU+fVxuICAgIHtwcm9wcy5jaGlsZHJlbn1cbiAgPC9TdHlsZWRJY29uPlxuKTtcblxuSWNvbkJhc2UuZGlzcGxheU5hbWUgPSAnSWNvbkJhc2UnO1xuXG5JY29uQmFzZS5kZWZhdWx0UHJvcHMgPSB7XG4gIHNpemU6IDI0LFxuICBjb2xvcjogJ2RhcmtCcmlnaHRCbHVlJyxcbiAgY2lyY2xlQ29sb3I6IG51bGwsXG4gIGNpcmNsZVBhZGRpbmc6ICczcHgnLFxuICBjaXJjbGVCb3JkZXJSYWRpdXM6ICc1MCUnLFxuICBhY3Rpb25JY29uOiBmYWxzZSxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IEljb25CYXNlO1xuIl19 */");
var IconBase = function IconBase(props) {
  return _react["default"].createElement(StyledIcon, (0, _extends2["default"])({}, props, {
    x: "0px",
    y: "0px",
    viewBox: props.viewBox ? props.viewBox : '0 0 64 64'
  }), props.title && _react["default"].createElement("title", null, props.title), props.children);
};
IconBase.displayName = 'IconBase';
IconBase.defaultProps = {
  size: 24,
  color: 'darkBrightBlue',
  circleColor: null,
  circlePadding: '3px',
  circleBorderRadius: '50%',
  actionIcon: false
};
var _default = IconBase;
exports["default"] = _default;
IconBase.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "IconBase",
  "props": {
    "size": {
      "defaultValue": {
        "value": "24",
        "computed": false
      },
      "required": false
    },
    "color": {
      "defaultValue": {
        "value": "'darkBrightBlue'",
        "computed": false
      },
      "required": false
    },
    "circleColor": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "required": false
    },
    "circlePadding": {
      "defaultValue": {
        "value": "'3px'",
        "computed": false
      },
      "required": false
    },
    "circleBorderRadius": {
      "defaultValue": {
        "value": "'50%'",
        "computed": false
      },
      "required": false
    },
    "actionIcon": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    }
  }
};
if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["icons/IconBase.js"] = {
    name: "IconBase",
    docgenInfo: IconBase.__docgenInfo,
    path: "icons/IconBase.js"
  };
}